import { supabase } from "@/lib/supabaseClient";

export type ImpromptuApiEndpoint =
  | "/api/impromptu/analyze"
  | "/api/impromptu/generate-prompt"
  | "/api/impromptu/pronunciation";

/**
 * Calls an Impromptu route with the browser's Supabase session when one exists.
 *
 * ChickyTutor deliberately stores web auth in localStorage, so a same-origin
 * request cannot rely on cookies to identify a signed-in learner. Keeping the
 * three Impromptu calls behind this helper prevents a paid or free account from
 * being silently downgraded to the anonymous quota.
 */
export async function fetchImpromptuApi(
  endpoint: ImpromptuApiEndpoint,
  init: RequestInit
): Promise<Response> {
  const headers = new Headers(init.headers);
  const {
    data: { session },
  } = await supabase.auth.getSession();

  if (session?.access_token) {
    headers.set("Authorization", `Bearer ${session.access_token}`);
  }

  return fetch(endpoint, {
    ...init,
    credentials: "same-origin",
    headers,
  });
}
